import { render, staticRenderFns } from "./tipModal.vue?vue&type=template&id=c5a2bfd4"
import script from "./tipModal.vue?vue&type=script&lang=js"
export * from "./tipModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports